import { bool } from "prop-types";

import styled from "styled-components";

import { AnimatePresence, motion } from "framer-motion";

import { inOutXSquish } from "UI/motionStyles";

const { CALL_TO_ACTION } = require("Giving/constants");

const SSpan = styled(motion.span)`
  font-style: italic;
  font-weight: 600;
  font-size: 20px;
  opacity: 0.5;
`;

const PlaceholderTitle = ({ show }) => {
  return (
    <AnimatePresence>
      {show && (
        <SSpan data-cy="Message_placeholder_text" {...inOutXSquish}>
          {CALL_TO_ACTION} Title
        </SSpan>
      )}
    </AnimatePresence>
  );
};

PlaceholderTitle.propTypes = { show: bool };

export default PlaceholderTitle;
